<template>
    <picture>
        <source media="(max-width: 1023px)" :srcset="getSrc('mobile')">
        <img media="(min-width: 1024px)" :srcset="getSrc('desktop')">
    </picture>
</template>

<script>
import store from '@/store/index.js'
export default {
    props: {
        src: {
            required: true
        }
    },
    data() {
        return {
            store
        }
    },
    computed: {
        baseUrl() {
            return this.store.state.baseUrl
        }
    },
    methods: {
        getSrc(format) {
            if (typeof this.src === 'object') {
                return `${this.baseUrl}${this.src[format]}`
            } else {
                return `/${format}/${this.src}`
            }
            // return `/wp-content/themes/betheme/corvocode/${format}/${this.src}`;
        }
    }
}
</script>